import { render, staticRenderFns } from "./mlItem.vue?vue&type=template&id=8050bf7e&scoped=true"
import script from "./mlItem.vue?vue&type=script&lang=js"
export * from "./mlItem.vue?vue&type=script&lang=js"
import style0 from "./mlItem.vue?vue&type=style&index=0&id=8050bf7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8050bf7e",
  null
  
)

export default component.exports